import { constructEnum } from '@/lib/enum';

const SizeRecommendationStep = constructEnum('SizeRecommendationStep', {
  INPUT: 0,
  LOADING: 1,
  RESULT: 2
});

export default SizeRecommendationStep;
